import dayjs from "dayjs";

export const cleanChartData = (data, isUsdAsset = false) => {
    const dataCleaned = []
    for (const i of data) {
        if (dataCleaned.length === 0) {
            dataCleaned.push(i)
        } else {
            const prev = dataCleaned[dataCleaned.length - 1]
            if (
                (!isUsdAsset && prev.r !== i.r) ||
                (isUsdAsset && prev.u !== i.u) ||
                dayjs(i.d).hour() !== dayjs(prev.d).hour()
            ) {
                dataCleaned.push(i)
            }
        }
    }
    return dataCleaned
}